import React from "react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useMonthlyQueriesByFaultCode } from "../../../hooks/StatisticsHooks";

/**
 * To draw the monthly queries by fault code bar chart
 */
export const MonthlyQueriesByFaultCodeVisualization = ({ faultCode, startDate, endDate }) => {
  const { data } = useMonthlyQueriesByFaultCode(faultCode, startDate, endDate);

  return (
    <ResponsiveContainer width="100%" height={600} margin={{ right: 50 }}>
      <BarChart data={data} margin={{ top: 20, right: 50 }}>
        <Legend verticalAlign="bottom" height={50} iconSize={30} />
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="mmYYYY" name="mmYYYY" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="numberOfTimes" fill="#5182BB" name="Number of times" />
      </BarChart>
    </ResponsiveContainer>
  );
};
